import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './index.scss';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string,
  domRef: PropTypes.func,
  style: PropTypes.object
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export default class Menu extends Component {
  static displayName = 'Menu';
  static propTypes = propTypes;

  static defaultProps = {
    domRef: function () {}
  };

  render() {
    const menuClasses = classnames('ndx-Menu', this.props.className);
    return (
      <div
        ref={this.props.domRef}
        className={menuClasses}
        style={this.props.style}>
        {this.props.children}
      </div>
    );
  }
}
